import styled from "styled-components"

import { fontWeight } from "~/utils/styles"

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 150px);
  min-height: 0;

  @supports (height: 100dvh) {
    max-height: calc(100dvh - 150px);
  }

  .form-footer {
    flex: 0 0 auto;
  }

  > section {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding: 20px;
    gap: 30px;
    width: 100%;
    > h3 {
      font-size: 24px;
      color: var(--blue);
      font-weight: 600;
    }
    > div {
      display: flex;
      flex-direction: column;
      gap: 20px;
      > p {
        font-size: 18px;
        ${fontWeight(500)}
      }
      > div {
        > input {
          min-width: 100px;
          width: fit-content;
          height: 50px;
          margin-left: 15px;
          background: white;
          border: 1px solid #c4c4c4;
          border-radius: 6px;
          padding: 0 15px;
          &:disabled {
            background: #f9f9f9;
            opacity: 0.5;
          }
        }
      }
    }
  }
`

const RateInputLabel = styled.div`
  display: flex;
  flex-direction: column;
  width: 157px;
  p {
    font-weight: 600;
    font-size: var(--step--2);
    color: var(--queen-blue);
    line-height: 9px;
    text-transform: capitalize;
    margin: 5px 0 20px;
    margin-bottom: 10px;
    position: relative;
  }
  > div {
    display: flex;
    align-items: flex-end;
    span {
      position: relative;
      padding-left: 10px;
      padding-bottom: 5px;
      > p {
        margin: 0;
        text-transform: none;
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        text-align: right;
        color: var(--grey-medium);
      }
      :last-of-type {
        cursor: pointer;
        padding-left: 5px;
        svg {
          stroke: var(--grey-medium);
          transform: translate(0, 4.5px);
          width: 16px;
        }
      }
    }
  }
  input {
    border-bottom: 1px solid rgba(51, 51, 51, 0.17);
    font-size: 16px;
    line-height: 19px;
    font-weight: 500;
    position: relative;
    z-index: 100;
    max-width: 40px;
    padding-left: 4px;
    padding-bottom: 5px;
  }
`

export const DownPaymentInput = styled(RateInputLabel)`
  input {
    max-width: 150px;
  }
`
